import { Route } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";

import { EventsPage } from "./EventsPage";

const eventsListLoader = loadSearchTablePreferences(
  queryClient,
  "event_search_table_preferences",
);

export const EventsRoutes = () => [
  <Route key={"/"} index loader={eventsListLoader} element={<EventsPage />} />,
];
